import { render, staticRenderFns } from "./ShSettingsPanel.vue?vue&type=template&id=2a76c75e&scoped=true&"
import script from "./ShSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./ShSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ShSettingsPanel.vue?vue&type=style&index=0&id=2a76c75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76c75e",
  null
  
)

export default component.exports